import React, { useState, useEffect } from 'react';

type ErrorState = { message: string; details: string; } | null;

interface ErrorDisplayProps {
    error: ErrorState;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => {
    const [showDetails, setShowDetails] = useState(false);

    // When the error prop changes, reset the details visibility to collapsed
    useEffect(() => {
        setShowDetails(false);
    }, [error]);

    if (!error) return null;

    return (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative mb-6 text-left" role="alert">
          <p className="font-medium">{error.message}</p>
          {error.details && (
            <div className="mt-2 text-xs">
              <button
                type="button"
                onClick={() => setShowDetails(!showDetails)}
                className="font-semibold hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-100 focus:ring-red-500 rounded bg-transparent border-none p-0 m-0 cursor-pointer text-red-700"
              >
                {showDetails ? '詳細を隠す' : '詳細を表示'}
              </button>
              {showDetails && (
                <pre className="mt-2 p-2 bg-red-50 rounded text-left whitespace-pre-wrap break-all font-mono">
                  <code>{error.details}</code>
                </pre>
              )}
            </div>
          )}
        </div>
    );
};

export default ErrorDisplay;
